import { authenticatedAtom, store } from '@/lib/store';
import { PROVIDERS } from '@/providers';
import { providerAtom } from '@/store/provider-atoms';

export const openWidget = () => {
  const provider = store.get(providerAtom);
  const isAuthenticated = store.get(authenticatedAtom);

  if (provider.id === PROVIDERS.SALESFORCE && !isAuthenticated) {
    return;
  }

  if (provider.openWidget) {
    provider.openWidget();
  }
};
